// import { Component, Inject } from '@angular/core';
// import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

// @Component({
//   selector: 'app-confirm-dialog',
//   template: `
//     <h2 mat-dialog-title>Confirm Delete</h2>
//     <mat-dialog-content>
//       Are you sure you want to delete this project?
//     </mat-dialog-content>
//     <mat-dialog-actions>
//       <button mat-button (click)="onNoClick()">Cancel</button>
//       <button mat-button color="warn" (click)="onYesClick()">Delete</button>
//     </mat-dialog-actions>
//   `,
// })
// export class ConfirmDialogComponent {
//   constructor(
//     public dialogRef: MatDialogRef<ConfirmDialogComponent>,
//     @Inject(MAT_DIALOG_DATA) public data: any
//   ) {}

//   onNoClick(): void {
//     this.dialogRef.close(false);
//   }

//   onYesClick(): void {
//     this.dialogRef.close(true);
//   }
// }
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DialogData {
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  isConfirm?: boolean;   // confirm dialog with Yes/No
  showButtons?: boolean; // show/hide all buttons
  autoClose?: number;    // auto-close delay in ms
}

@Component({
  selector: 'app-confirm-dialog',
  template: `
    <h2 mat-dialog-title>{{ data.title || 'Notice' }}</h2>
    <mat-dialog-content>
      {{ data.message || '' }}
    </mat-dialog-content>
    <mat-dialog-actions align="end" *ngIf="data.showButtons !== false">
      <button mat-button *ngIf="data.isConfirm" (click)="onCancel()">
        {{ data.cancelText || 'Cancel' }}
      </button>
      <button mat-button color="primary" (click)="onConfirm()">
        {{ data.isConfirm ? (data.confirmText || 'OK') : 'OK' }}
      </button>
    </mat-dialog-actions>
  `,
  // pre-line so a message that deliberately contains newlines renders as
  // lines — the batch-invite summary lists one failed vendor per line, and
  // interpolation otherwise collapses them into one run-on paragraph.
  // `pre-line` (not `pre`) still collapses runs of spaces and still wraps, so
  // single-line messages elsewhere are unaffected.
  styles: [`
    mat-dialog-content { white-space: pre-line; }
  `],
})
export class ConfirmDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit() {
    if (this.data.autoClose) {
      setTimeout(() => this.dialogRef.close(true), this.data.autoClose);
    }
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
